import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';

const GM_DIR_URL = 'https://www.google.com/maps/dir/Your+Location';

export const getDirectionSettings = ({
  getDirections
}: Partial<ChatsChannelBase>) => {
  if (!getDirections) return null;

  const url = `${GM_DIR_URL}/${getDirections}`;

  return {
    provider: ChatsChannelType.getdirection,
    title: 'Get Directions',
    link: { url, options: { withFeatures: false } },
    color: 'rgb(25, 123, 255)',
    icon: getChatIcon(ChatsChannelType.getdirection)
  } as ChatsChannelSetting;
};
